var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSweatyFacePaymentFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5569 33C26.3594 33 33.4952 25.6127 33.4952 16.5C33.4952 7.3873 26.3594 0 17.5569 0C8.75446 0 1.61865 7.3873 1.61865 16.5C1.61865 25.6127 8.75446 33 17.5569 33Z",
    fill: "url(#paint0_radial_3693_17199)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5569 33C26.3594 33 33.4952 25.6127 33.4952 16.5C33.4952 7.3873 26.3594 0 17.5569 0C8.75446 0 1.61865 7.3873 1.61865 16.5C1.61865 25.6127 8.75446 33 17.5569 33Z",
    fill: "url(#paint1_radial_3693_17199)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5569 33C26.3594 33 33.4952 25.6127 33.4952 16.5C33.4952 7.3873 26.3594 0 17.5569 0C8.75446 0 1.61865 7.3873 1.61865 16.5C1.61865 25.6127 8.75446 33 17.5569 33Z",
    fill: "url(#paint2_radial_3693_17199)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5569 33C26.3594 33 33.4952 25.6127 33.4952 16.5C33.4952 7.3873 26.3594 0 17.5569 0C8.75446 0 1.61865 7.3873 1.61865 16.5C1.61865 25.6127 8.75446 33 17.5569 33Z",
    fill: "url(#paint3_radial_3693_17199)",
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3693_17199",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 33,
    height: 33
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.49 33C26.2925 33 33.4283 25.6127 33.4283 16.5C33.4283 7.3873 26.2925 0 17.49 0C8.68757 0 1.55176 7.3873 1.55176 16.5C1.55176 25.6127 8.68757 33 17.49 33Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3693_17199)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3693_17199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.46163 16.0293C1.47894 15.7949 1.55346 15.7714 1.5752 16.0094C1.59935 16.2739 1.5524 16.8056 1.56371 17.1264C1.59363 17.9756 1.71938 18.714 1.84902 19.3146C2.26676 21.2502 2.84528 22.4974 3.38487 23.5541C5.15855 27.0276 7.10146 28.7865 8.99684 30.1121C11.7751 32.0552 14.576 32.6733 17.3792 32.8044C17.4499 32.8077 17.4616 33.2845 17.3921 33.3466C17.2667 33.4585 17.1113 33.3474 16.9829 33.3428C16.6142 33.3294 16.2455 33.3032 15.8768 33.2635C14.7835 33.1459 13.6903 32.9064 12.5994 32.5211C9.63302 31.4733 6.43466 29.6793 3.64144 24.6264C3.46572 24.3085 3.2914 23.9738 3.11954 23.6142C2.9821 23.3266 2.846 23.0251 2.7123 22.7027C2.27252 21.6421 1.24769 18.9272 1.46163 16.0293ZM17.3811 33.3517C17.3137 33.3538 17.2966 32.9094 17.3609 32.8171C17.4581 32.6776 17.6037 32.7925 17.7062 32.7858C18.1317 32.7583 18.5571 32.7175 18.9824 32.6622C20.1484 32.5106 21.3137 32.2518 22.4763 31.8532C25.36 30.8646 28.4602 29.3574 31.1786 24.7269C31.3516 24.4322 31.5231 24.1195 31.6923 23.7834C32.2065 22.7621 33.4953 20.051 33.3463 16.6807C33.3338 16.3966 33.4173 16.2265 33.4547 16.4702C33.5023 16.7805 33.483 17.4275 33.4699 17.7717C33.4279 18.8742 33.2643 19.8066 33.0919 20.5596C32.5454 22.9459 31.7781 24.3295 31.0754 25.4848C28.7916 29.2398 26.311 30.7536 23.8994 31.8414C21.7364 32.8171 19.5569 33.2822 17.3811 33.3517Z",
    fill: "#401C02"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3693_17199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.46163 16.0293C1.47894 15.7949 1.55346 15.7714 1.5752 16.0094C1.59935 16.2739 1.5524 16.8056 1.56371 17.1264C1.59363 17.9756 1.71938 18.714 1.84902 19.3146C2.26676 21.2502 2.84528 22.4974 3.38487 23.5541C5.15855 27.0276 7.10146 28.7865 8.99684 30.1121C11.7751 32.0552 14.576 32.6733 17.3792 32.8044C17.4499 32.8077 17.4616 33.2845 17.3921 33.3466C17.2667 33.4585 17.1113 33.3474 16.9829 33.3428C16.6142 33.3294 16.2455 33.3032 15.8768 33.2635C14.7835 33.1459 13.6903 32.9064 12.5994 32.5211C9.63302 31.4733 6.43466 29.6793 3.64144 24.6264C3.46572 24.3085 3.2914 23.9738 3.11954 23.6142C2.9821 23.3266 2.846 23.0251 2.7123 22.7027C2.27252 21.6421 1.24769 18.9272 1.46163 16.0293ZM17.3811 33.3517C17.3137 33.3538 17.2966 32.9094 17.3609 32.8171C17.4581 32.6776 17.6037 32.7925 17.7062 32.7858C18.1317 32.7583 18.5571 32.7175 18.9824 32.6622C20.1484 32.5106 21.3137 32.2518 22.4763 31.8532C25.36 30.8646 28.4602 29.3574 31.1786 24.7269C31.3516 24.4322 31.5231 24.1195 31.6923 23.7834C32.2065 22.7621 33.4953 20.051 33.3463 16.6807C33.3338 16.3966 33.4173 16.2265 33.4547 16.4702C33.5023 16.7805 33.483 17.4275 33.4699 17.7717C33.4279 18.8742 33.2643 19.8066 33.0919 20.5596C32.5454 22.9459 31.7781 24.3295 31.0754 25.4848C28.7916 29.2398 26.311 30.7536 23.8994 31.8414C21.7364 32.8171 19.5569 33.2822 17.3811 33.3517Z",
    fill: "#401C02"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2842 18.005C20.224 17.9421 20.1833 17.8619 20.1675 17.7748C20.1517 17.6877 20.1615 17.5977 20.1957 17.5165C20.9781 15.6543 22.814 14.3462 24.9538 14.3462C27.0936 14.3462 28.9268 15.6543 29.7119 17.5165C29.7463 17.5977 29.7563 17.6877 29.7405 17.7749C29.7247 17.862 29.6838 17.9422 29.6233 18.005C29.5451 18.0846 29.4403 18.1299 29.3306 18.1316C29.221 18.1332 29.1149 18.0911 29.0345 18.0138C28.0558 17.0998 26.5914 16.5176 24.9538 16.5176C23.3162 16.5176 21.8478 17.0985 20.8737 18.0132C20.7934 18.0905 20.6873 18.1328 20.5776 18.1312C20.4679 18.1295 20.363 18.084 20.2849 18.0043L20.2842 18.005Z",
    fill: "url(#paint4_radial_3693_17199)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44501 18.005C5.38464 17.9421 5.34392 17.8619 5.32813 17.7748C5.31233 17.6877 5.32221 17.5977 5.35646 17.5165C6.1389 15.6543 7.97473 14.3462 10.1145 14.3462C12.2544 14.3462 14.0882 15.6543 14.8726 17.5165C14.907 17.5977 14.9169 17.6878 14.9009 17.775C14.885 17.8621 14.8441 17.9423 14.7834 18.005C14.7053 18.0845 14.6006 18.1299 14.4911 18.1315C14.3815 18.1332 14.2756 18.091 14.1953 18.0138C13.2166 17.0998 11.7521 16.5176 10.1139 16.5176C8.47565 16.5176 7.01122 17.0985 6.03449 18.0132C5.95416 18.0905 5.84807 18.1328 5.73835 18.1312C5.62864 18.1295 5.52378 18.084 5.44567 18.0043L5.44501 18.005Z",
    fill: "url(#paint5_radial_3693_17199)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2842 18.005C20.224 17.9421 20.1833 17.8619 20.1675 17.7748C20.1517 17.6877 20.1615 17.5977 20.1957 17.5165C20.9781 15.6543 22.814 14.3462 24.9538 14.3462C27.0936 14.3462 28.9268 15.6543 29.7119 17.5165C29.7463 17.5977 29.7563 17.6877 29.7405 17.7749C29.7247 17.862 29.6838 17.9422 29.6233 18.005V18.005C29.5451 18.0846 29.4403 18.1299 29.3306 18.1316C29.221 18.1332 29.1149 18.0911 29.0345 18.0138C28.0558 17.0998 26.5914 16.5176 24.9538 16.5176C23.3162 16.5176 21.8478 17.0985 20.8737 18.0132C20.7934 18.0905 20.6873 18.1328 20.5776 18.1312C20.4679 18.1295 20.363 18.084 20.2849 18.0043L20.2842 18.005Z",
    stroke: "url(#paint6_linear_3693_17199)",
    strokeWidth: 0.140474,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44501 18.005C5.38464 17.9421 5.34392 17.8619 5.32813 17.7748C5.31233 17.6877 5.32221 17.5977 5.35646 17.5165C6.1389 15.6543 7.97473 14.3462 10.1145 14.3462C12.2544 14.3462 14.0882 15.6543 14.8726 17.5165C14.907 17.5977 14.9169 17.6878 14.9009 17.775C14.885 17.8621 14.8441 17.9423 14.7834 18.005V18.005C14.7053 18.0845 14.6006 18.1299 14.4911 18.1315C14.3815 18.1332 14.2756 18.091 14.1953 18.0138C13.2166 17.0998 11.7521 16.5176 10.1139 16.5176C8.47565 16.5176 7.01122 17.0985 6.03449 18.0132C5.95416 18.0905 5.84807 18.1328 5.73835 18.1312C5.62864 18.1295 5.52378 18.084 5.44567 18.0043L5.44501 18.005Z",
    stroke: "url(#paint7_linear_3693_17199)",
    strokeWidth: 0.140474,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8376 27.3849C12.812 27.4054 12.7808 27.417 12.7484 27.4181C12.7161 27.4192 12.6842 27.4097 12.6574 27.391C12.6305 27.3723 12.61 27.3453 12.5988 27.3139C12.5877 27.2824 12.5863 27.2481 12.595 27.2159C13.1429 25.0533 15.132 23.4531 17.5025 23.4531C19.8729 23.4531 21.8641 25.0567 22.4106 27.2207C22.4196 27.253 22.4184 27.2874 22.4073 27.319C22.3961 27.3506 22.3756 27.3777 22.3486 27.3964C22.3216 27.4151 22.2896 27.4245 22.2572 27.4231C22.2247 27.4218 22.1935 27.4098 22.1681 27.389C20.9884 26.4551 19.3337 25.8736 17.5025 25.8736C15.6713 25.8736 14.0178 26.4531 12.8376 27.3849Z",
    fill: "url(#paint8_radial_3693_17199)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8376 27.3849C12.812 27.4054 12.7808 27.417 12.7484 27.4181C12.7161 27.4192 12.6842 27.4097 12.6574 27.391C12.6305 27.3723 12.61 27.3453 12.5988 27.3139C12.5877 27.2824 12.5863 27.2481 12.595 27.2159C13.1429 25.0533 15.132 23.4531 17.5025 23.4531C19.8729 23.4531 21.8641 25.0567 22.4106 27.2207C22.4196 27.253 22.4184 27.2874 22.4073 27.319C22.3961 27.3506 22.3756 27.3777 22.3486 27.3964C22.3216 27.4151 22.2896 27.4245 22.2572 27.4231C22.2247 27.4218 22.1935 27.4098 22.1681 27.389C20.9884 26.4551 19.3337 25.8736 17.5025 25.8736C15.6713 25.8736 14.0178 26.4531 12.8376 27.3849Z",
    stroke: "url(#paint9_linear_3693_17199)",
    strokeWidth: 0.175593,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3693_17199",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 33,
    height: 33
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.491 33C26.2935 33 33.4293 25.6127 33.4293 16.5C33.4293 7.3873 26.2935 0 17.491 0C8.68855 0 1.55273 7.3873 1.55273 16.5C1.55273 25.6127 8.68855 33 17.491 33Z",
    fill: "url(#paint10_radial_3693_17199)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3693_17199)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter2_f_3693_17199)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.297521 12.0232C0.269104 9.79156 4.09474 3.69385 4.09474 3.69385C4.09474 3.69385 8.07436 9.68209 8.10343 11.9137C8.10455 12.9768 7.701 13.9975 6.98022 14.7547C6.25943 15.5119 5.27948 15.9446 4.25269 15.959C3.2259 15.9734 2.23499 15.5683 1.49466 14.8316C0.754329 14.0949 0.324217 13.0859 0.297521 12.0232Z",
    fill: "#743C1C",
    fillOpacity: 0.7
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.49674 10.9285C0.468323 8.69683 4.29396 2.59912 4.29396 2.59912C4.29396 2.59912 8.27357 8.58737 8.30265 10.819C8.30377 11.8821 7.90022 12.9028 7.17943 13.66C6.45865 14.4172 5.4787 14.8498 4.45191 14.8642C3.42512 14.8786 2.43421 14.4736 1.69388 13.7369C0.953547 13.0002 0.523436 11.9912 0.49674 10.9285Z",
    fill: "url(#paint11_linear_3693_17199)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3693_17199",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 9,
    height: 13
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.497228 10.9285C0.468811 8.69683 4.29445 2.59912 4.29445 2.59912C4.29445 2.59912 8.27406 8.58737 8.30314 10.819C8.30426 11.8821 7.9007 12.9028 7.17992 13.66C6.45914 14.4172 5.47918 14.8498 4.4524 14.8642C3.42561 14.8786 2.43469 14.4736 1.69437 13.7369C0.954036 13.0002 0.523924 11.9912 0.497228 10.9285Z",
    fill: "url(#paint12_linear_3693_17199)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3693_17199)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3693_17199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.26407 15.4616C-0.461068 15.4616 -0.989514 10.3647 0.365203 9.1333C0.365203 10.2621 0.893886 13.9565 4.26407 13.9565C7.20496 13.9565 8.59273 10.8094 8.42752 9.1333C10.0796 10.3305 8.98923 15.4616 4.26407 15.4616Z",
    fill: "#7CD3FF"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3693_17199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.80963 10.0095C2.79809 8.70254 4.35267 5.13135 4.35267 5.13135C4.35267 5.13135 5.96981 8.63843 5.98163 9.94543C5.98208 10.568 5.8181 11.1658 5.5252 11.6093C5.23231 12.0527 4.83409 12.3061 4.41685 12.3146C3.99961 12.323 3.59694 12.0858 3.2961 11.6543C2.99526 11.2229 2.82048 10.6319 2.80963 10.0095Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3693_17199",
    x: -0.32331,
    y: 14.0859,
    width: 35.5641,
    height: 21.0665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.877964,
    result: "effect1_foregroundBlur_3693_17199"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3693_17199",
    x: -1.37687,
    y: 13.0323,
    width: 37.6712,
    height: 23.1737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40474,
    result: "effect1_foregroundBlur_3693_17199"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3693_17199",
    x: -2.16093,
    y: 1.23555,
    width: 12.7227,
    height: 17.1822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.22915,
    result: "effect1_foregroundBlur_3693_17199"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3693_17199",
    x: -1.407,
    y: 8.00951,
    width: 11.6822,
    height: 8.57571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.561897,
    result: "effect1_foregroundBlur_3693_17199"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3693_17199",
    x: 0.0000870228,
    y: 2.32186,
    width: 8.79084,
    height: 12.8026,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40474,
    result: "effect1_foregroundBlur_3693_17199"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3693_17199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.545) rotate(90) scale(32.9754 31.8528)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3693_17199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.545 4.41268) rotate(90) scale(28.5627 27.5903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782278
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3693_17199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.545 4.41268) rotate(90) scale(28.5627 27.5903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782278
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3693_17199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.545 -3.59171) rotate(90) scale(36.5671 47.7682)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0922635,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.670207,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3693_17199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9473 16.2377) scale(6.11094 1.896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#743C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401C02"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3693_17199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1079 16.2376) scale(6.11089 1.89597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#743C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401C02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3693_17199",
    x1: 24.954,
    y1: 18.2381,
    x2: 24.954,
    y2: 14.2244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FED93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F9AF21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3693_17199",
    x1: 10.1146,
    y1: 18.2381,
    x2: 10.1146,
    y2: 14.2244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FED93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F9AF21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D14"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3693_17199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.503 25.4302) scale(3.7089 4.01005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#743C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401C02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3693_17199",
    x1: 17.503,
    y1: 27.535,
    x2: 17.503,
    y2: 23.3254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FFDE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D14"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3693_17199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.4791) rotate(90) scale(32.9754 31.8528)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3693_17199",
    x1: 4.74503,
    y1: 15.6288,
    x2: 4.61754,
    y2: 3.31379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0736292,
    stopColor: "#0048FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223403,
    stopColor: "#006DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403627,
    stopColor: "#0090FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535088,
    stopColor: "#00ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00CBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3693_17199",
    x1: 4.74552,
    y1: 15.6288,
    x2: 4.61803,
    y2: 3.31379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0048FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#006DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#0090FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00CBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CFFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweatyFacePaymentFailed);
export default __webpack_public_path__ + "static/media/sweaty_face_payment_failed.4c7b8f71f3314ec257ad8e3929c32a55.svg";
export { ForwardRef as ReactComponent };